import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { PageHeader } from "@/components/pages/common/PageHeader";
import { AddingWidget } from "@/components/pages/dashboard/components/adding-widget/AddingWidget";
import { useAppSelector } from "@/store/hooks";
import { dashboardWidgetsSelector } from "@/store/dashboards/selectors/dashboard/dashboardWidgetsSelector";
import { getDashboardByIdLoadingSelector } from "@/store/dashboards/selectors/dashboard/loadings/getDashboardByIdLoadingSelector";
import { currentUserSelector } from "@/store/profile/currentUserSelector";

interface HomeDashboardHeaderProps {
  dashboardId?: string;
}

export const HomeDashboardHeader: FC<HomeDashboardHeaderProps> = ({
  dashboardId,
}) => {
  const widgetsData = useAppSelector(dashboardWidgetsSelector);
  const dashboardByIdLoading = useAppSelector((state) =>
    getDashboardByIdLoadingSelector(state, dashboardId ?? ""),
  );
  const user = useAppSelector(currentUserSelector);

  return (
    <PageHeader
      sticky
      loading={dashboardByIdLoading}
      title={
        <Stack direction="row" spacing={1} alignItems="center">
          <HomeOutlinedIcon fontSize="small" />
          <Typography>
            Welcome back, {user?.name?.split(" ")?.at(0) || user?.email}
          </Typography>
        </Stack>
      }
      actions={
        <Stack
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {!!widgetsData?.length && <AddingWidget startIcon />}
        </Stack>
      }
    />
  );
};
